<template>
  <van-steps :direction="direction" :active="active">
    <van-step v-for="(item, index) in data" :key="index">
      <h3>{{item.Text}}</h3>
      <p>{{item.CreateTimeStr}}</p>
    </van-step>
  </van-steps>
</template>

<script>
  export default {
    name: 'trSteps',
    props: {
      data: {
        type: Array,
        default: () => {
          return []
        }
      },
      active: {
        type: Number,
        default: () => {
          return 0
        }
      },
      direction: {
        type: String,
        default: () => {
          return 'vertical'
        }
      }
    }
  }
</script>

<style scoped>

</style>